var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBMCnt7LeftLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 450,
    viewBox: "0 0 514 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M484 0H0V450H313C342 424 292 370 286.5 340C281 310 280 199.5 436 112.5C474.028 91.2922 484 61 484 0Z",
    fill: "url(#paint0_linear_1341_31084)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M480.5 0H0V450H277C234 381 299 323.5 308.5 288.5C315.14 264.038 298.098 231 314.5 196.5C337.557 148 409 109.25 444.5 66C464.919 41.1229 473.442 26.761 480.5 0Z",
    fill: "url(#paint1_linear_1341_31084)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M231 333C240 393.5 248 423.5 213 450H0V0H421C397.5 62.5 367 102.5 337 129.5C284.938 176.356 262.836 191.488 242.5 234.5C223.352 275 224.206 287.329 231 333Z",
    fill: "url(#paint2_linear_1341_31084)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M421 0H0V450H203.5C228.5 407.5 230.5 376 234 341C236.85 312.5 230.625 285 252 240C276.225 189 305.195 156.521 333.5 119C355 90.5 402.5 43.5 421 0Z",
    fill: "url(#paint3_linear_1341_31084)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M323.5 0H0V450H169.5C191.5 402 198.5 396 192.5 338.5C186.5 281 215.5 213.5 239 185.5C262.5 157.5 299 110.5 310.5 83.5C322 56.5 323.5 36.5 323.5 0Z",
    fill: "url(#paint4_linear_1341_31084)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M347.5 0H0V450H139.5C161.5 402 170 378 162 326.5C154 275 210.5 207.5 234 179.5C257.5 151.5 299.5 118 319.5 93.5C339.5 69 351 39 347.5 0Z",
    fill: "url(#paint5_linear_1341_31084)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M228 0H0V450H100.5C126.5 425.5 146.275 384.362 127.5 331C118 304 120 254 166 202.5C210.638 152.525 232.265 126.937 236.5 92C240.5 59 236 28 228 0Z",
    fill: "url(#paint6_linear_1341_31084)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M94.5 0H0V431.5C40.5 413.5 68.0471 372.412 61 330.5C51.5 274 45 233 69.5 193.5C94 154 124 112.5 127 78.5C129.182 53.7717 112 17 94.5 0Z",
    fill: "url(#paint7_linear_1341_31084)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M45 92.5C42.5 52.5 25.8468 31.1244 0 11.5V225C8.5 169.5 47.934 139.444 45 92.5Z",
    fill: "url(#paint8_linear_1341_31084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1341_31084",
    x1: 1201.9,
    y1: -315.469,
    x2: 1222.65,
    y2: 417.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#00637B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1341_31084",
    x1: 1124.66,
    y1: -315.469,
    x2: 1146.83,
    y2: 417.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#00637B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1341_31084",
    x1: -0.0000146982,
    y1: -39,
    x2: 17.5186,
    y2: 510.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FC0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1341_31084",
    x1: -0.0000146982,
    y1: -39,
    x2: 17.5186,
    y2: 510.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00637B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1341_31084",
    x1: 815.703,
    y1: -315.469,
    x2: 846.244,
    y2: 416.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#00637B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1341_31084",
    x1: 815.703,
    y1: -315.469,
    x2: 846.245,
    y2: 416.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#00637B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1341_31084",
    x1: 45,
    y1: -100.5,
    x2: 240.629,
    y2: 390.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00637B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1341_31084",
    x1: 268,
    y1: -302.5,
    x2: 352.37,
    y2: 390.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930111,
    stopColor: "#00637B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1341_31084",
    x1: 0.00000493472,
    y1: -19.5,
    x2: 51.9531,
    y2: 245.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00637B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBMCnt7LeftLines);
export default __webpack_public_path__ + "static/media/b_m_cnt7_left_lines.7212ccf133b0ec47f715b169aa4fd292.svg";
export { ForwardRef as ReactComponent };